import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { map, Observable, of, switchMap } from 'rxjs';

import {
  addHeaderToRequest,
  hasRequestHeader,
  ORG_ID_HEADER_KEY,
  removeHeaderFromRequest,
  WITH_MANUAL_ORG_ID_FLAG_KEY,
  WITH_ORG_ID_FLAG_KEY,
} from '@pp/core/helpers';
import { StorageStore } from '@pp/core/store';

let withOrgId: boolean;
let withManualOrgId: boolean;

function handleWithOrgIdFlag(newRequest: HttpRequest<any>): HttpRequest<any> {
  withOrgId = hasRequestHeader(newRequest, WITH_ORG_ID_FLAG_KEY);
  withManualOrgId = hasRequestHeader(newRequest, WITH_MANUAL_ORG_ID_FLAG_KEY);
  newRequest = removeHeaderFromRequest(newRequest, WITH_ORG_ID_FLAG_KEY);
  newRequest = removeHeaderFromRequest(newRequest, WITH_MANUAL_ORG_ID_FLAG_KEY);

  return newRequest;
}

function sendRequestWithAddingOrgId(next: HttpHandlerFn, newRequest: HttpRequest<any>): Observable<HttpEvent<any>> {
  const storageStore = inject(StorageStore);
  const orgId$ = withManualOrgId ? of(storageStore.manuallySelectedOrgId()) : of(storageStore.getStoredOrgId());

  return orgId$.pipe(
    map(orgId => addOrgIdHeader(orgId, newRequest)),
    switchMap(req => next(req)),
  );
}

function addOrgIdHeader(orgId: number | unknown, newRequest: HttpRequest<any>): HttpRequest<any> {
  return addHeaderToRequest(newRequest, ORG_ID_HEADER_KEY, orgId.toString());
}

export function OrgIdInterceptor(request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const newRequest = handleWithOrgIdFlag(request.clone());

  const needsOrgId = withOrgId || withManualOrgId;
  const shouldAddOrgId = needsOrgId && !hasRequestHeader(newRequest, ORG_ID_HEADER_KEY);

  return shouldAddOrgId ? sendRequestWithAddingOrgId(next, newRequest) : next(newRequest);
}
